const id_companyProfile = {
    "": "profil perusahaan",
    account: "nama akun",
    address: "alamat perusahaan",
    code: "kode perusahaan",
    email: "email perusahaan",
    fax: "fax perusahaan",
    id: "ID perusahaan",
    logo: "logo perusahaan",
    name: "nama perusahaan",
    phone: "telepon perusahaan",
    tax: "nomor pajak perusahaan",

    error: {
        code: "Kode perusahaan tidak boleh kosong.",
        name: "Nama perusahaan tidak boleh kosong.",
        address: "Alamat perusahaan tidak boleh kosong.",
        update: "Gagal mengubah data perusahaan.",
        pass: "Gagal mengubah kata sandi."
    },

    success: {
        update: "Berhasil mengubah data perusahaan.",
        pass: "Berhasil mengubah kata sandi."
    },
}

export default id_companyProfile;